export type Client = {
  id: string;
  emailAddress?: string | null;
  firstName: string;
  lastName: string;
  personalDetails: PersonalDetails;
  dependants: Dependant[];
  familyId?: string;
  family?: ClientFamilyDetails;
  advisorUserId?: string;
  advised: boolean;
  createdAt: string;
};

type ClientFamilyDetails = {
  id: string;
  name: string;
} & (
  | {
      isMainFamilyMember: true;
    }
  | {
      isMainFamilyMember: false;
      relationshipToMainFamilyMember: string;
    }
);

type PersonalDetails = {
  firstName: string;
  lastName?: string;
  phoneNumber?: string;
  address?: string;
  dateOfBirth?: string;
  preferredName?: string;
  gender?: string;
  title?: string;
  maritalStatus?: string;
  nationalInsuranceNumber?: string;
  placeOfBirth?: string;
  nationality?: string;
  ukResidencyStatus?: string;
  domiciledInUk?: boolean;
  isBankrupt?: boolean;
  isRetired?: boolean;
};

type Dependant = {
  id: string;
  firstName?: string;
  lastName?: string;
  relationship?: string;
  age?: number;
  dependentUntilAge?: number;
};

export const USER_ROLES = ['ADVISOR', 'SYSTEM_ADMIN', 'SERVICE_ADMIN'] as const;
export type UserRole = (typeof USER_ROLES)[number];

export const USER_STATUSES = ['ACTIVE', 'DEACTIVATED', 'PENDING', 'ARCHIVED'] as const;
export type UserStatus = (typeof USER_STATUSES)[number];

export type User = {
  id: string;
  emailAddress: string;
  firstName: string;
  lastName: string;
  userRole: UserRole;
  createdAt: string;
  userStatus: UserStatus;
};

export type AvailableActions =
  | 'edit'
  | 'deactivate'
  | 'reactivate'
  | 'archive'
  | 'unarchive'
  | 'resendInvite'
  | 'delete';
